<template>
  <div class="rl-map">
    <div slot="header">
      <div>
        <!-- <template> -->
        <!--            <el-select v-model="queryInfo.status" placeholder="请选择车辆状态" style="margin-left: 20px" @change="updateMaker">-->
        <!--              <el-option-->
        <!--                v-for="item in bikechange"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!-- <el-select v-model="queryInfo.statustype" placeholder="请选择查询方式" style="margin-left: 20px"
                       @change="updateMaker">
              <el-option
                v-for="item in bikechangestatustype"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select v-model="queryInfo.hour" placeholder="请选择查询时间段" style="margin-left: 20px" @change="updateMaker"
                       v-if="this.queryInfo.statustype === 0">
              <el-option
                v-for="item in bikechangehour"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template> -->
        <template>
          <div class="map-type">
            <span>{{ $t('operate.name72') }}</span>
            <el-radio v-model="mapchange" label="1">{{ $t('operate.name73') }}</el-radio>
            <el-radio v-model="mapchange" label="2">{{ $t('operate.name74') }}</el-radio>
          </div>
        </template>
      </div>
    </div>
    <template>
      <div v-show="mapchange === '1'">
        <!-- <GmapMap :center=centergoole :zoom='8' ref="mapRef" class="map">
            <gmap-cluster>
              <gmap-info-window :options="infoOptionsgoole" :position="infoWindowPosgoole" :opened="infoWinOpengoole"
                                @closeclick="infoWinOpengoole=false">
              </gmap-info-window>
              <GmapMarker @dragend="updateMaker"
                          :key="index" v-for="(marker, index) in markersgoole"
                          :position="marker.position"
                          :clickable="true"
                          @click="infowindowgoole(marker,index)"
                          class="map-marker"
                          :label="marker.label">
              </GmapMarker>
            </gmap-cluster>
          </GmapMap> -->
        <template>
          <heat-map class="bm-view" :initialZoom='8' :points="hotmarkersgoole" :lat="centergoole.lat"
            :lng="centergoole.lng" :height="500" />
        </template>
      </div>
      <div v-show="mapchange === '2'">
        <!-- <baidu-map class="bm-view" :center=centerbaidu :zoom='8' :scroll-wheel-zoom='true'>
            <bml-marker-clusterer :averageCenter="true">
              <bm-info-window :position="infoWindowPosbaidu" :show="infoWinOpenbaidu"
                              @clickclose="infoWinOpenbaidu=false" :open="infoWinOpenbaidu">
                <p v-html="infoOptionsbaidu.content"></p>
              </bm-info-window>
              <bm-marker v-for="(marker, index) in markersbaidu" :key="index" @click="infowindowbaidu(marker,index)"
                         :position="marker.position"></bm-marker>
            </bml-marker-clusterer>
          </baidu-map> -->
        <!-- <baidu-map class="bm-view" :center=centerbaidu :zoom="8" :scroll-wheel-zoom='true'  @ready="handleMap">
            <bml-heatmap :data="hotmarkersbaidu" :max="100" :radius="20">
            </bml-heatmap>
          </baidu-map> -->
        <div id="mapDiv" class="bm-view"></div>
      </div>
    </template>
  </div>
</template>
<script>
// import GmapCluster from 'vue2-google-maps/src/components/cluster'
import coordtransform from 'coordtransform'
// import { BmlHeatmap } from 'vue-baidu-map'
import HeatMap from '@/components/HeatMap'
import { getEbikeMap } from '@/api/home.js'
export default {
  components: {
    HeatMap
    // GmapCluster,
    // BmlHeatmap
    // BmlMarkerClusterer
  },
  props: {
    tenantType: {
      type: String,
      default: () => null
    },
    tenantId: {
      type: String,
      default: () => null
    },
    startTime: {
      type: String,
      default: () => '2024-04'
    },
    endTime: {
      type: String,
      default: () => '2025-03'
    }
  },
  watch: {
    tenantId () {
      this.updateMaker()
    },
    startTime () {
      this.updateMaker()
    },
    endTime () {
      this.updateMaker()
    }
  },
  data () {
    return {
      datassss: [],
      mapchange: '2',
      centergoole: {
        lng: 0,
        lat: 0
      },
      queryInfo: {
        status: '',
        statustype: 0,
        hour: 24
      },
      bikechange: [{
        value: '',
        label: '全部'
      }, {
        value: 0,
        label: '损坏'
      }, {
        value: 1,
        label: '正常可以'
      }, {
        value: 2,
        label: '正在使用'
      }],
      bikechangestatustype: [{
        value: 0,
        label: '时间查询'
      }, {
        value: 1,
        label: '已认证车辆查询'
      }, {
        value: 2,
        label: '所有车辆查询'
      }],
      bikechangehour: [{
        value: 12,
        label: '12小时'
      }, {
        value: 24,
        label: '24小时'
      }, {
        value: 36,
        label: '36小时'
      }, {
        value: 48,
        label: '48小时'
      }],
      // goole
      hotmarkersgoole: [],
      infoWindowPosgoole: null,
      infoWinOpengoole: false,
      currentMidxgoole: null,
      infoOptionsgoole: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      zoom: 8,
      status: '',
      markersgoole: [],
      // baidu
      hotmarkersbaidu: [],
      infoWindowPosbaidu: null,
      infoWinOpenbaidu: false,
      currentMidxbaidu: null,
      markersbaidu: [],
      infoOptionsbaidu: { content: '' },
      centerbaidu: {
        lng: 0,
        lat: 0
      },
      tMap: null,
      heatmapOverlay: null,
      T: null
    }
  },
  created () {
    this.updateMaker()
  },
  mounted () {
  },
  methods: {
    chinascope (lng, lat) {
      if (lng < 72.004 || lng > 137.8347 || (lat < 0.8293 || lat > 55.8271)) {
        return true
      } else {
        return true
      }
    },
    handleMap ({ BMap, map }) {
      // this.map = map
      // this.BMap = BMap
      // this.updateMaker()
    },
    async updateMaker () {
      this.markersgoole = []
      this.markersbaidu = []
      this.hotmarkersbaidu = []
      const data = {
        tenantType: this.tenantType,
        tenantId: this.tenantId,
        startTime: this.startTime,
        endTime: this.endTime
      }
      getEbikeMap(data)
        .then((res) => {
          console.log('====', res)
          const iotEbikeProfileList = []
          res.data.map((item) => {
            if (item.lat && item.lng) {
              iotEbikeProfileList.push(item)
            }
          })
          if (iotEbikeProfileList.length > 0) {
            iotEbikeProfileList.forEach((item) => {
              if (this.chinascope(item.lng, item.lat) === true) {
                const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
                this.hotmarkersgoole.push({
                  lng: Number(bikepoint[0]),
                  lat: Number(bikepoint[1])
                })
                this.markersgoole.push({
                  ebikeId: item.ebikeId,
                  position: {
                    lng: Number(bikepoint[0]),
                    lat: Number(bikepoint[1])
                  },
                  infoText:
                    '<div><span>IOT编号 :</span>' +
                    item.ebikeId +
                    '</div>' +
                    '<div><span>车辆mac :</span>' +
                    item.mac +
                    '</div>' +
                    '<div><span>车锁的状态 :</span>' +
                    item.lockStatus +
                    '</div>' +
                    '<div><span>速度 :</span>' +
                    item.speed +
                    '</div>' +
                    '<div><span>电量 :</span>' +
                    item.soc +
                    '</div>' +
                    '<div><span>车辆状态 :</span>' +
                    item.status +
                    '</div>' +
                    '<div><span>经度 :</span>' +
                    item.lng +
                    '</div>' +
                    '<div><span>纬度 :</span>' +
                    item.lat +
                    '</div>' +
                    '<div><span>高度 :</span>' +
                    item.alt +
                    '</div>' +
                    '<div><span>轨迹时间 :</span>' +
                    item.gisTime +
                    '</div>' +
                    '<div><span>备注 :</span>' +
                    item.remark +
                    '</div>'
                })
              } else {
                const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
                this.hotmarkersgoole.push({
                  lng: Number(bikepoints[0]),
                  lat: Number(bikepoints[1])
                })
                this.markersgoole.push({
                  ebikeId: item.ebikeId,
                  position: {
                    lng: Number(item.lng),
                    lat: Number(item.lat)
                  },
                  infoText:
                    '<div><span>IOT编号 :</span>' +
                    item.ebikeId +
                    '</div>' +
                    '<div><span>车辆mac :</span>' +
                    item.mac +
                    '</div>' +
                    '<div><span>车锁的状态 :</span>' +
                    item.lockStatus +
                    '</div>' +
                    '<div><span>速度 :</span>' +
                    item.speed +
                    '</div>' +
                    '<div><span>电量 :</span>' +
                    item.soc +
                    '</div>' +
                    '<div><span>车辆状态 :</span>' +
                    item.status +
                    '</div>' +
                    '<div><span>经度 :</span>' +
                    item.lng +
                    '</div>' +
                    '<div><span>纬度 :</span>' +
                    item.lat +
                    '</div>' +
                    '<div><span>高度 :</span>' +
                    item.alt +
                    '</div>' +
                    '<div><span>轨迹时间 :</span>' +
                    item.gisTime +
                    '</div>' +
                    '<div><span>备注 :</span>' +
                    item.remark +
                    '</div>'
                })
              }
            })
            this.centergoole = {
              lat: this.markersgoole[0].position.lat,
              lng: this.markersgoole[0].position.lng
            }
            iotEbikeProfileList.forEach((item) => {
              // const bikepointbaidu = coordtransform.wgs84togcj02(item.lng, item.lat)
              // const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
              this.hotmarkersbaidu.push({
                lng: item.lng,
                lat: item.lat,
                count: 30
              })
              this.markersbaidu.push({
                ebikeId: item.ebikeId,
                position: {
                  lng: item.lng,
                  lat: item.lat
                },
                infoText:
                  '<div><span>IOT编号 :</span>' +
                  item.ebikeId +
                  '</div>' +
                  '<div><span>车辆mac :</span>' +
                  item.mac +
                  '</div>' +
                  '<div><span>车锁的状态 :</span>' +
                  item.lockStatus +
                  '</div>' +
                  '<div><span>速度 :</span>' +
                  item.speed +
                  '</div>' +
                  '<div><span>电量 :</span>' +
                  item.soc +
                  '</div>' +
                  '<div><span>车辆状态 :</span>' +
                  item.status +
                  '</div>' +
                  '<div><span>经度 :</span>' +
                  item.lng +
                  '</div>' +
                  '<div><span>纬度 :</span>' +
                  item.lat +
                  '</div>' +
                  '<div><span>高度 :</span>' +
                  item.alt +
                  '</div>' +
                  '<div><span>轨迹时间 :</span>' +
                  item.gisTime +
                  '</div>' +
                  '<div><span>备注 :</span>' +
                  item.remark +
                  '</div>'
              })
            })
            this.centerbaidu = {
              lat: this.markersbaidu[0].position.lat,
              lng: this.markersbaidu[0].position.lng
            }

            if (this.tMap == null) {
              this.T = window.T
              this.tMap = new this.T.Map('mapDiv')
              this.heatmapOverlay = new this.T.HeatmapOverlay({ radius: 30 })
            }
            this.setMapOverlay()
          } else {
            // this.$message({
            //   message: '没有该类型的数据',
            //   type: 'error'
            // })
          }
        })
        .catch(() => { })
      // const iotEbikeProfileList = [
      //   {
      //     lng: '119.056013',
      //     lat: '31.668381',
      //     ebikeId: '',
      //     mac: '',
      //     lockStatus: '开锁',
      //     speed: '800',
      //     soc: '',
      //     status: '',
      //     alt: '41.3',
      //     gisTime: '2025-03-10 16:57:27',
      //     remark: '111'
      //   },
      //   {
      //     lng: '119.055990',
      //     lat: '31.668401',
      //     ebikeId: '',
      //     mac: '',
      //     lockStatus: '开锁',
      //     speed: '800',
      //     soc: '',
      //     status: '',
      //     alt: '43.5',
      //     gisTime: '2025-03-10 16:59:53',
      //     remark: '111'
      //   }
      // ]
      // } else if (this.queryInfo.statustype === 1) {
      //   const res = await this.$API.bikelist.reqfindAuthEbikeGisProfileList({ status: this.queryInfo.status })
      //   if (res.result.data.iotEbikeProfileList) {
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       if (this.chinascope(item.lng, item.lat) === true) {
      //         const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoint[0]),
      //           lat: Number(bikepoint[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(bikepoint[0]),
      //             lat: Number(bikepoint[1])
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       } else {
      //         const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoints[0]),
      //           lat: Number(bikepoints[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(item.lng),
      //             lat: Number(item.lat)
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       }
      //     })
      //     this.centergoole = {
      //       lat: this.markersgoole[0].position.lat,
      //       lng: this.markersgoole[0].position.lng
      //     }
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       const bikepointbaidu = coordtransform.wgs84togcj02(item.lng, item.lat)
      //       const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
      //       this.hotmarkersbaidu.push({
      //         lng: Number(bikepointsbaidu[0]),
      //         lat: Number(bikepointsbaidu[1]),
      //         count: 30
      //       })
      //       this.markersbaidu.push({
      //         ebikeId: item.ebikeId,
      //         position: {
      //           lng: Number(bikepointsbaidu[0]),
      //           lat: Number(bikepointsbaidu[1])
      //         },
      //         infoText:
      //           '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //           '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //           '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //           '<div><span>速度 :</span>' + item.speed + '</div>' +
      //           '<div><span>电量 :</span>' + item.soc + '</div>' +
      //           '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //           '<div><span>经度 :</span>' + item.lng + '</div>' +
      //           '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //           '<div><span>高度 :</span>' + item.alt + '</div>' +
      //           '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //           '<div><span>备注 :</span>' + item.remark + '</div>'
      //       })
      //     })
      //     this.centerbaidu = {
      //       lat: this.markersbaidu[0].position.lat,
      //       lng: this.markersbaidu[0].position.lng
      //     }
      //   } else {
      //     this.$message({
      //       message: '没有该类型的数据',
      //       type: 'error',
      //       offset: 60
      //     })
      //   }
      // } else if (this.queryInfo.statustype === 2) {
      //   const res = await this.$API.bikelist.reqfindEbikeAllGisProfileList({ status: this.queryInfo.status })
      //   if (res.result.data.iotEbikeProfileList) {
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       if (this.chinascope(item.lng, item.lat) === true) {
      //         const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoint[0]),
      //           lat: Number(bikepoint[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(bikepoint[0]),
      //             lat: Number(bikepoint[1])
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       } else {
      //         const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoints[0]),
      //           lat: Number(bikepoints[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(item.lng),
      //             lat: Number(item.lat)
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       }
      //     })
      //     this.centergoole = {
      //       lat: this.markersgoole[0].position.lat,
      //       lng: this.markersgoole[0].position.lng
      //     }
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       const bikepointbaidu = coordtransform.wgs84togcj02(item.lng, item.lat)
      //       const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
      //       this.hotmarkersbaidu.push({
      //         lng: Number(bikepointsbaidu[0]),
      //         lat: Number(bikepointsbaidu[1]),
      //         count: 30
      //       })
      //       this.markersbaidu.push({
      //         ebikeId: item.ebikeId,
      //         position: {
      //           lng: Number(bikepointsbaidu[0]),
      //           lat: Number(bikepointsbaidu[1])
      //         },
      //         infoText:
      //           '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //           '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //           '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //           '<div><span>速度 :</span>' + item.speed + '</div>' +
      //           '<div><span>电量 :</span>' + item.soc + '</div>' +
      //           '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //           '<div><span>经度 :</span>' + item.lng + '</div>' +
      //           '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //           '<div><span>高度 :</span>' + item.alt + '</div>' +
      //           '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //           '<div><span>备注 :</span>' + item.remark + '</div>'
      //       })
      //     })
      //     this.centerbaidu = {
      //       lat: this.markersbaidu[0].position.lat,
      //       lng: this.markersbaidu[0].position.lng
      //     }
      //   } else {
      //     this.$message({
      //       message: '没有该类型的数据',
      //       type: 'error',
      //       offset: 60
      //     })
      //   }
      // }
    },
    setMapOverlay () {
      var zoom = 4
      this.tMap.centerAndZoom(new this.T.LngLat(this.centerbaidu.lng, this.centerbaidu.lat), zoom)
      this.tMap.clearOverLays()
      this.tMap.addOverLay(this.heatmapOverlay)
      this.heatmapOverlay.setDataSet({ data: this.hotmarkersbaidu, max: 300 })
    },
    async infowindowgoole (marker, idx) {
      const res = await this.$API.bikelist.reqgetEbikeEmail({
        ebikeId: marker.ebikeId
      })
      if (res.result.code !== 200) {
        return this.$message.error(res.result.errorMsg)
      }
      this.infoWindowPosgoole = marker.position
      this.infoOptionsgoole.content = marker.infoText + '<div><span>车辆邮箱 :</span>' + res.result.data.email + '</div>'
      this.centergoole = {
        lat: marker.position.lat,
        lng: marker.position.lng
      }
      if (this.currentMidxgoole === idx) {
        this.infoWinOpengoole = !this.infoWinOpengoole
      } else {
        this.infoWinOpengoole = true
        this.currentMidxgoole = idx
      }
    },
    async infowindowbaidu (marker, idx) {
      const res = await this.$API.bikelist.reqgetEbikeEmail({
        ebikeId: marker.ebikeId
      })
      if (res.result.code !== 200) {
        return this.$message.error(res.result.errorMsg)
      }
      this.infoWindowPosbaidu = marker.position
      this.infoOptionsbaidu.content = marker.infoText + '<div><span>车辆邮箱 :</span>' + res.result.data.email + '</div>'
      this.centerbaidu = {
        lat: marker.position.lat,
        lng: marker.position.lng
      }
      if (this.currentMidxbaidu === idx) {
        this.infoWinOpenbaidu = !this.infoWinOpenbaidu
      } else {
        this.infoWinOpenbaidu = true
        this.currentMidxbaidu = idx
      }
    }
  }
}

</script>
<style lang="scss">
.el-radio {
  font-weight: 800 !important;
}
</style>
<style lang="scss" scoped>
.rl-map {
  width: 50%;
  position: relative;
}

.map-type {
  position: absolute;
  left: 15px;
  top: 10px;
  display: flex;
  flex-direction: row;
  z-index: 1000;
  font-weight: 800;
  align-items: center;
}

.map {
  width: 100%;
  height: calc(100vh - 360px);
}

.bm-view {
  width: 100%;
  height: calc(100vh - 360px) !important;
}
</style>
